<template>
   <div class='layer-radio mb-1'>
      <div class="mb-0 w-100 d-flex" style="justify-content: space-between; align-content: flex-start;">
         <label :style="{width: '80%', fontSize: languageIsEnglish ? '12px': '13px'}" :for="layer.id">
            <input 
               class="mr-2"
               type="radio"
               @click="$emit('radio-select', {layer, opacity})"
               :name="groupId"
               :id="layer.id"
               :value="layer.id"
               :checked="layer.visible"
            >
            {{ languageIsEnglish ? layer.titleEnglish : layer.titleNepali }}
         </label>
         <a class="side-icons">
            <img
               class="source-info"
               src="../../assets/icons/info.svg"
               :title="description"
            >
            <img 
               src="../../assets/icons/down-arrow.svg"
               :class="{'flip-up': showLegend}"
               :title="showLegend ? 'Show less' : 'Show more'"
               @click="showLegend=!showLegend"
            >
         </a>
      </div>
      <div v-if="showLegend">
         <img class="legend" :src="languageIsEnglish ? layer.legendPath : layer.legendPathNepali">
         <br>
         <vue-slider
            v-if="opacitySlider"
            class="slider"
            :min="0" :max="1" :interval="0.01"
            v-model="opacity"
            :title="`Change opacity(${opacity*100}%)`"
            @change="$emit('change-opacity', {opacity, layer:layer })"
         />
      </div>
   </div>
</template>

<script>

export default {
   props: {
      opacitySlider: { type: Boolean },
      layer: { type: Object, required: true },
      languageIsEnglish: { type: Boolean, required: true },
      groupId: { type: String, required: true },
   },
   data()
   {
      return {
         opacity: 1,
         // showLegend: false,
      };
   },
   computed: {
      showLegend: {
         get() {
            return this.layer.legendIsShown;
         },
         set(showLegend) {
            this.$emit('show-legend', showLegend)
         }
      },
      description()
      {
         return this.languageIsEnglish ?
            `Source: ${this.layer.sourceInfo || 'N/A'}\nDescription: ${this.layer.description || 'N/A'}`
            :
            `स्रोत: ${this.layer.sourceInfoNepali || 'N/A'}\nविवरण: ${this.layer.descriptionNepali || 'N/A'}`;
      }
   },
}
</script>

<style scoped>
.layer-radio {
   overflow: hidden;
}
label {
   font-size: 12px;
   font-weight: 500;
   cursor: pointer;
}
input {
   cursor: pointer;
}
.side-icons {
   float: right;
}
.side-icons img {
   margin: 0 1px;
   width: 14px;
   cursor: pointer;
}
.legend {
   margin-left: 20px;
}
.flip-up {
   transform: rotate(180deg);
}
.slider {
   margin-right: 1.5em;
   margin-left: 1.5em;
}
</style>